export default "__VITE_ASSET__837cab14__"